<div class="recording-page">
  <header *ngIf="inNewShell" class="recording-page__brand-bar">
    <img src="/scryber-logo-lime.png?v=4" alt="Scryber" />
  </header>
  <div class="recording-page__inner">
    <div class="page-heading">
      <div class="page-heading__title-row">
        <h1 class="page-title">Record visit</h1>
        <div
          *ngIf="microphonePickerAvailable && !orphanedPausedResume"
          class="mic-picker"
          (keydown.escape)="closeMicrophoneMenu()">
          <button
            type="button"
            class="mic-picker__trigger"
            [class.mic-picker__trigger--open]="microphoneMenuOpen"
            [disabled]="microphoneSwitching || isTranscribing || savingPausedVisit"
            [attr.aria-expanded]="microphoneMenuOpen"
            aria-haspopup="listbox"
            aria-label="Select microphone"
            (click)="toggleMicrophoneMenu($event)">
            <svg class="mic-picker__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
              <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
            </svg>
            <span class="mic-picker__label">{{ selectedMicrophoneLabel }}</span>
            <svg class="mic-picker__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="m6 9 6 6 6-6"/>
            </svg>
          </button>
          <div *ngIf="microphoneMenuOpen" class="mic-picker__menu" role="listbox" aria-label="Microphones">
            <p *ngIf="!microphones.length" class="mic-picker__empty">No microphones found</p>
            <button
              *ngFor="let mic of microphones"
              type="button"
              class="mic-picker__option"
              role="option"
              [attr.aria-selected]="mic.deviceId === activeMicrophoneId"
              [class.mic-picker__option--selected]="mic.deviceId === activeMicrophoneId"
              [disabled]="microphoneSwitching"
              (click)="selectMicrophone(mic.deviceId)">
              <span class="mic-picker__check" aria-hidden="true">
                <svg *ngIf="mic.deviceId === activeMicrophoneId" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path d="M20 6 9 17l-5-5"/>
                </svg>
              </span>
              <span class="mic-picker__option-label">{{ mic.label }}</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="inNewShell" class="recording-patient">
        <div *ngIf="!editingRecordingPatient" class="recording-patient__row">
          <p class="page-subtitle">{{ recordingPatientLabel || 'Unknown' }}</p>
          <button
            type="button"
            class="recording-patient__edit"
            [class.recording-patient__edit--unknown]="isRecordingPatientUnknown"
            title="Edit patient name"
            aria-label="Edit patient name"
            (click)="startRecordingPatientEdit()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
            </svg>
          </button>
        </div>
        <div *ngIf="editingRecordingPatient" class="recording-patient__editor">
          <div class="recording-patient__editor-row">
            <div class="recording-patient__field">
              <input
                #recordingPatientInput
                type="text"
                class="recording-patient__input"
                autocomplete="off"
                placeholder="Patient name"
                [ngModel]="recordingPatientNameDraft"
                (ngModelChange)="onRecordingPatientNameDraftChange($event)"
                (keydown)="onRecordingPatientNameKeydown($event)"
                [disabled]="recordingPatientNameSaving"
                aria-label="Edit patient name"
                aria-autocomplete="list"
                [attr.aria-expanded]="recordingNameDropdownOpen" />
              <div
                *ngIf="recordingNameDropdownOpen && recordingNameSuggestions.length"
                class="recording-patient__dropdown"
                role="listbox">
                <button
                  *ngFor="let patient of recordingNameSuggestions; let i = index"
                  type="button"
                  class="recording-patient__option"
                  role="option"
                  [class.recording-patient__option--active]="recordingNameHighlight === i"
                  (mousedown)="$event.preventDefault()"
                  (click)="selectRecordingPatientSuggestion(patient)"
                  (mouseenter)="recordingNameHighlight = i">
                  <span class="recording-patient__option-name">{{ patient.firstName }} {{ patient.lastName }}</span>
                  <span *ngIf="patient.mrn" class="recording-patient__option-meta">MRN {{ patient.mrn }}</span>
                </button>
              </div>
            </div>
            <div class="recording-patient__actions">
              <button
                type="button"
                class="recording-patient__save"
                title="Save"
                aria-label="Save patient name"
                [disabled]="recordingPatientNameSaving"
                (click)="saveRecordingPatientName($event)">
                <span *ngIf="recordingPatientNameSaving">…</span>
                <svg *ngIf="!recordingPatientNameSaving" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </button>
              <button
                type="button"
                class="recording-patient__cancel"
                title="Cancel"
                aria-label="Cancel editing patient name"
                [disabled]="recordingPatientNameSaving"
                (click)="cancelRecordingPatientEdit($event)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <p *ngIf="recordingPatientNameError" class="recording-patient__error" role="alert">
            {{ recordingPatientNameError }}
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="orphanedPausedResume" class="orphan-paused-banner">
      <div class="orphan-paused-banner__text">
        <p class="orphan-paused-banner__message">
          Draft audio for this visit is not on this browser, so it can't be resumed. Please delete this recording.
        </p>
      </div>
      <div class="orphan-paused-banner__actions">
        <button
          type="button"
          class="btn btn-primary orphan-paused-delete-btn"
          [disabled]="orphanPausedDeleteBusy"
          (click)="deleteOrphanPausedRecordingFromBanner()">
          {{ orphanPausedDeleteBusy ? 'Deleting…' : 'Delete recording' }}
        </button>
      </div>
    </div>

    <div *ngIf="!inNewShell" class="info-card">
      <div class="form-grid">
        <div class="form-group">
          <label for="patientName" class="form-label">
            <span class="form-label__text">
              Patient Name
              <em class="form-label__optional">(optional)</em>
            </span>
            <a
              href="#"
              class="create-patient-link"
              [class.create-patient-link--busy]="creatingPatientFromName"
              (click)="createPatientFromNameAndStart(); $event.preventDefault()">
              {{ creatingPatientFromName ? 'Creating…' : 'Create New Patient' }}
            </a>
          </label>
          <div class="autocomplete-container">
            <p-autoComplete
              id="patientName"
              [(ngModel)]="selectedPatientDisplay"
              [suggestions]="filteredPatients"
              (completeMethod)="onCompletePatientSearch($event)"
              (onSelect)="onPatientSelectFromDropdown($event.value)"
              (onClear)="onPatientClear()"
              optionLabel="displayName"
              placeholder="Search for patient.."
              [disabled]="isRecording"
              [minLength]="0"
              [showEmptyMessage]="false"
              [dropdown]="false"
              inputStyleClass="form-input"
              styleClass="patient-autocomplete">
            </p-autoComplete>
          </div>
        </div>
      </div>
    </div>

    <!-- Recording Section -->
    <div class="recording-card">
      <div class="card-header">
        <p class="card-subtitle" *ngIf="!isAppendVisitFlow">Record your patient consultation</p>
        <p class="card-subtitle" *ngIf="isAppendVisitFlow">
          Add more audio to this visit — it will be merged and re-transcribed when you stop.
        </p>
      </div>
      
      <div class="recording-controls">
        <!-- Validation Errors Display -->
        <div *ngIf="!isFormReady() && hasAttemptedRecording" class="validation-errors">
          <div class="error-message">
            <svg class="error-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            Please complete all required fields before recording
          </div>
        </div>
        
        <div class="timer">
          <span id="recording-timer" [textContent]="recordingTime"></span>
        </div>
        
        <div class="recording-buttons">
          <!-- Record: new visit only (paused / add-more use Resume / End instead) -->
          <button 
            *ngIf="showNewVisitRecordButton"
            class="record-button"
            [disabled]="showShortRecordingModal || orphanResumeBlocksRecording"
            (click)="onStartRecording()">
            <svg class="mic-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
              <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
            </svg>
          </button>

          <ng-container *ngIf="isResumedVisitIdle">
            <div class="recording-btn-with-label">
              <button
                type="button"
                class="pause-button paused"
                [disabled]="showShortRecordingModal || orphanResumeBlocksRecording"
                (click)="onStartRecording()">
                <svg class="play-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </button>
              <span class="recording-btn-label">Resume</span>
            </div>
            <div class="recording-btn-with-label">
              <button
                type="button"
                class="stop-button"
                [disabled]="isTranscribing || showShortRecordingModal || orphanResumeBlocksRecording"
                (click)="onEndResumedVisitFromIdle()">
                <svg class="stop-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 6h12v12H6z"/>
                </svg>
              </button>
              <span class="recording-btn-label">End</span>
            </div>
          </ng-container>

          <ng-container *ngIf="isAppendVisitIdle">
            <div class="recording-btn-with-label">
              <button
                type="button"
                class="pause-button paused"
                [disabled]="showShortRecordingModal || orphanResumeBlocksRecording"
                (click)="onStartRecording()">
                <svg class="play-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </button>
              <span class="recording-btn-label">Resume</span>
            </div>
            <div class="recording-btn-with-label">
              <button
                type="button"
                class="stop-button"
                [disabled]="isTranscribing || showShortRecordingModal || orphanResumeBlocksRecording"
                (click)="onEndAppendVisitFromIdle()">
                <svg class="stop-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 6h12v12H6z"/>
                </svg>
              </button>
              <span class="recording-btn-label">End</span>
            </div>
          </ng-container>
          
          <div *ngIf="showMicPauseWhileRecording" class="recording-btn-with-label">
            <button 
              class="pause-button"
              [class.paused]="isPaused"
              [disabled]="orphanResumeBlocksRecording || savingPausedVisit"
              (click)="onPauseRecording()">
              <svg *ngIf="!isPaused" class="pause-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
              </svg>
              <svg *ngIf="isPaused" class="play-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </button>
            <span class="recording-btn-label">{{ savingPausedVisit ? 'Saving…' : (isPaused ? 'Resume' : 'Pause') }}</span>
          </div>
          
          <div *ngIf="isRecording" class="recording-btn-with-label">
            <button 
              class="stop-button"
              [disabled]="orphanResumeBlocksRecording || savingPausedVisit"
              (click)="onStopRecording()">
              <svg class="stop-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 6h12v12H6z"/>
              </svg>
            </button>
            <span class="recording-btn-label">{{ isPausedVisitResumeFlow ? 'End' : 'Stop' }}</span>
          </div>
        </div>
        
        <!-- Recording Status -->
        <div *ngIf="isRecording" class="recording-status">
          {{ getRecordingStatusText() }}
        </div>
        <div *ngIf="isTranscribing" class="recording-status processing">
          Processing your recording…
        </div>
      </div>

    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <div class="spacer"></div>
      <button 
        class="btn btn-secondary"
        (click)="onCancel()">
        Cancel
      </button>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showNavigatePauseWarning"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [style]="{ width: 'min(520px, 92vw)' }"
  [header]="isAppendVisitFlow ? 'Discard this addition?' : 'Confirm Pause'">
  <p class="recording-dialog-body">
    <ng-container *ngIf="isAppendVisitFlow">
      Your new audio will not be saved or merged. The existing visit recording stays as it was. Continue?
    </ng-container>
    <ng-container *ngIf="!isAppendVisitFlow">
      Pause this visit and save your progress? You can resume it later from
      {{ inNewShell ? 'Visits' : 'Transcriptions' }}.
    </ng-container>
  </p>
  <ng-template pTemplate="footer">
    <div class="recording-dialog-footer">
      <button type="button" class="btn-text" (click)="onNavigatePauseWarningCancel()">Cancel</button>
      <button type="button" class="btn-text btn-text-primary" (click)="onNavigatePauseWarningContinue()">
        {{ isAppendVisitFlow ? 'Discard' : 'Pause' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showDeleteOrphanPausedConfirmDialog"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [style]="{ width: 'min(520px, 92vw)' }"
  header="Delete paused recording">
  <p class="recording-dialog-body">
    Delete paused recording for "{{ orphanedPausedResume?.patientDisplay || 'this paused visit' }}"? This cannot be
    undone.
  </p>
  <ng-template pTemplate="footer">
    <div class="recording-dialog-footer">
      <button
        type="button"
        class="btn-text"
        [disabled]="orphanPausedDeleteBusy"
        (click)="onCancelDeleteOrphanPausedRecording()">
        Cancel
      </button>
      <button
        type="button"
        class="btn-text btn-text-danger"
        [disabled]="orphanPausedDeleteBusy"
        (click)="onConfirmDeleteOrphanPausedRecording()">
        Delete
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showPauseForLaterDialog"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [style]="{ width: 'min(520px, 92vw)' }"
  header="Pause Recording">
  <p class="recording-dialog-body">
    Who is the patient for this paused visit? You can resume at any time.
  </p>
  <div class="recording-dialog-field">
    <label for="pausePatientName">Patient name</label>
    <p-autoComplete
      id="pausePatientName"
      [(ngModel)]="pauseModalPatientName"
      [suggestions]="pauseModalPatientSuggestions"
      (completeMethod)="onPauseModalPatientSearch($event)"
      (onSelect)="onPauseModalPatientSelect($event.value)"
      (ngModelChange)="onPauseModalPatientNameChange()"
      optionLabel="nameOnly"
      optionValue="nameOnly"
      [minLength]="0"
      [showEmptyMessage]="false"
      [dropdown]="false"
      [autofocus]="true"
      appendTo="body"
      panelStyleClass="pause-patient-autocomplete-panel"
      inputStyleClass="form-input pause-patient-input"
      styleClass="pause-patient-autocomplete"
      placeholder="Type patient name">
    </p-autoComplete>
  </div>
  <p class="recording-dialog-tip">
    <span class="tip-icon" aria-hidden="true">💡</span>
    Tip: Enter the patient’s name before starting the visit to access patient summaries and get more accurate notes.
  </p>
  <ng-template pTemplate="footer">
    <div class="recording-dialog-footer">
      <button type="button" class="btn-text" [disabled]="savingPausedVisit" (click)="onPauseForLaterSkip()">
        {{ savingPausedVisit ? 'Saving…' : 'Skip' }}
      </button>
      <button
        type="button"
        class="btn-text btn-text-primary"
        [disabled]="savingPausedVisit || !canConfirmPausePatientName()"
        (click)="onPauseForLaterConfirm()">
        {{ savingPausedVisit ? 'Saving…' : 'Confirm name' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showShortRecordingModal"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [style]="{ width: 'min(520px, 92vw)' }"
  header="Recording is very short">
  <p class="recording-dialog-body">
    Visits under {{ minRecordingSecondsForUpload }} seconds usually do not produce a useful note. You can keep
    recording this visit or start over with a clean slate.
  </p>
  <ng-template pTemplate="footer">
    <div class="recording-dialog-footer">
      <button type="button" class="btn-text btn-text-danger" (click)="startOverAfterShortRecordingWarning()">
        Start over
      </button>
      <button type="button" class="btn-text btn-text-primary" (click)="resumeAfterShortRecordingWarning()">
        Resume recording
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
